<template>
  <div>
    <div>
      <h3>Leads</h3>
      <b-form-group>
        <b-form-input label="Search" placeholder="Search Leads" v-model="name" @input="getLeads"></b-form-input>
      </b-form-group>
      <loading-panel v-if="loading"></loading-panel>
      <div v-else>
        <b-list-group class="mt-4" v-if="leads.length > 0">
          <b-list-group-item v-for="lead in leads" :key="lead.id" class="d-flex justify-content-between align-items-center">
            {{ lead.name }}
            <b-button size="sm" variant="primary" @click="showLead(lead)"><i class="fas fa-eye"></i> View</b-button>
          </b-list-group-item>
        </b-list-group>
        <h3 class="text-danger text-center" v-else>No Leads</h3>
      </div>
    </div>

    <b-modal scrollable id="lead-modal" @hidden="clearLead" hide-footer>
      <template #modal-title>
        <div class="d-flex align-items-center" v-if="lead.picture">
          <span class="avatar avatar-sm rounded-circle mr-3">
            <img :alt="lead.name + ' image'" :src="lead.picture.small">
          </span>
          <span>
            {{ lead.name}}<br>
            <span class="small text-muted">Last Activity: {{ lead.lastActivity }}</span>
          </span>
        </div>
      </template>
      <div class="d-flex justify-content-between align-items-center">
        <span v-if="lead.phones" class="text-muted small"><i class="fas fa-phone"></i> {{ lead.phones[0].value }}</span>
        <span v-if="lead.emails" class="text-muted small"><i class="fas fa-envelope"></i> {{ lead.emails[0].value }}</span>
        <b-dropdown variant="info" size="sm" id="lead-actions" text="Actions">
          <b-dropdown-item @click="createPipeline">Create Pipeline</b-dropdown-item>
          <b-dropdown-item @click="createListing">Create Listing</b-dropdown-item>
          <b-dropdown-item @click="createTransaction">Create Transaction</b-dropdown-item>
        </b-dropdown>
      </div>
      <b-card no-body class="mt-3 mb-3" v-if="lead">
        <b-card-header header-tag="header" href="#" role="tab" v-b-toggle.details>
          <div class="d-flex justify-content-between">
            <h5 class="mb-0"><i class="fas fa-list"></i> Details</h5>
            <i class="fas fa-angle-up"></i>
          </div>
        </b-card-header>
        <b-collapse id="details" visible accordion="details" role="tabpanel">
          <b-card-body>
            <div class="small">
              <strong>Stage:</strong> {{ lead.stage }}<br>
              <strong>Source:</strong> {{ lead.source }}<br>
              <strong>Agent:</strong> {{ lead.assignedTo }}<br>
              <strong>Price:</strong> {{ lead.price | currency }}<br>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mt-3 mb-3" v-if="lead.addresses">
        <b-card-header header-tag="header" href="#" role="tab" v-b-toggle.addresses>
          <div class="d-flex justify-content-between">
            <h5 class="mb-0"><i class="fas fa-home"></i> Addresses ({{ lead.addresses.length }})</h5>
            <i class="fas fa-angle-up"></i>
          </div>
        </b-card-header>
        <b-collapse id="addresses" visible accordion="addresses" role="tabpanel">
          <b-card-body>
            <div v-for="(address, index) in lead.addresses" :key="address.id" class="mb-3 small">
              <strong>Address {{ index + 1 }}:</strong> {{ address.street }} {{ address.city }}, {{ address.state }} {{ address.code }}
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-3" v-if="lead.relationships">
        <b-card-header header-tag="header" href="#" role="tab" v-b-toggle.relationships>
          <div class="d-flex justify-content-between">
            <h5 class="mb-0"><i class="fas fa-users"></i> Relationships <span class="text-muted">({{ lead.relationships.length }})</span></h5>
            <i class="fas fa-angle-up"></i>
          </div>
        </b-card-header>
        <b-collapse id="relationships" visible accordion="relationships" role="tabpanel">
          <b-card-body>
            <div v-for="relationship in lead.relationships" :key="relationship.id" class="mb-3 small">
              <strong>{{ relationship.firstName }}</strong><br>
              <i class="fas fa-phone text-muted"></i> {{ relationship.phones[0].value }} ({{ relationship.phones[0].type }})<br>
              <i class="fas fa-envelope text-muted"></i> {{ relationship.emails[0].value }}<br>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import LoadingPanel from '@/components/LoadingPanel';

export default {
  components: {
    LoadingPanel
  },
  data() {
    return {
      loading: false,
      leads: [],
      name: '',
      lead: {
        id: '',
        name: '',
        emails: null,
        phones: null,
        stage: '',
        source: '',
        assignedTo: '',
        lastActivity: '',
        relationships: null,
        picture: null
      }
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    })
  },
  methods: {
    async getLeads() {
      this.loading = true;

      await axios.get(this.userRoute + "/integrations/fub/people/leads?name=" + this.name)
      .then(response => {
        this.leads = response.data;
        this.loading = false;
      })
      .catch(error => {
        // 
      });
    },
    showLead(lead) {
      this.lead = lead;
      this.$bvModal.show('lead-modal');
    },
    clearLead() {
      this.lead = {
        id: '',
        name: '',
        emails: null,
        phones: null,
        stage: '',
        source: '',
        assignedTo: ''
      };
    },
    createPipeline() {
      this.$router.push({
        path: '/pipelines/create?person=' + this.lead.id
      });
    },
    createListing() {
      this.$router.push({
        path: '/listings/create?person=' + this.lead.id
      });
    },
    createTransaction() {
      this.$router.push({
        path: '/transactions/create?person=' + this.lead.id
      });
    }
  },
  created() {
    this.getLeads();
  }
};
</script>